import { Box, Flex } from "@chakra-ui/react";

import { TextSecondary } from "theme";

import { default as IconContainer } from "@components/Icon";

import { StrapiCommunityDetails } from "@customtypes/global";
import { getCommunityIcon } from "@utils/globalCommon";

interface SocialItemProps {
  socialItems: StrapiCommunityDetails;
  onClick(key: string): void;
}

const Socials = ({ socialItems, onClick }: SocialItemProps) => {
  const { section_details = {}, communities_data = [] } = socialItems;
  return (
    <Flex
      bg={{ base: "inherit", xl: "backgroundSecondary" }}
      p={{ base: "0", xl: "1rem" }}
      flexDir="column"
      alignItems={{ base: "flex-start", xl: "center" }}
      borderRadius="1rem 1rem 0 0"
      mt={{ base: "40px", xl: 0 }}
      mb={{ base: "72px", xl: 0 }}
    >
      {section_details?.title && (
        <TextSecondary fontWeight="400" fontSize="12px" lineHeight="18px">
          Join our community
        </TextSecondary>
      )}
      <Flex
        mt="0.5rem"
        justifyContent={{ base: "flex-start", xl: "center" }}
        alignItems="center"
        width={{ base: "100px", xl: "148px" }}
        gap={{ base: "1rem", xl: "12px" }}
      >
        {communities_data.map((item) => (
          <a
            href={item.link}
            target="_blank"
            rel="noreferrer"
            key={item.key}
            onClick={() => onClick(item?.key || "")}
          >
            <Box
              transition="all 0.15s ease-in-out"
              _hover={{
                color: "primary",
                transform: "scale(1.2)",
              }}
            >
              {item?.img_key && (
                <IconContainer
                  width="24px"
                  height="24px"
                  Icon={getCommunityIcon(item.img_key)}
                  color="textPrimary"
                />
              )}
            </Box>
          </a>
        ))}
      </Flex>
    </Flex>
  );
};

export default Socials;
